export const discountCalc = (realPrice, discount) => {
  return ((discount / realPrice) * 100).toFixed(1);
};
